import { render, staticRenderFns } from "./AcutePancreatiti.vue?vue&type=template&id=1f76f3ee&scoped=true"
import script from "./AcutePancreatiti.vue?vue&type=script&lang=js"
export * from "./AcutePancreatiti.vue?vue&type=script&lang=js"
import style0 from "./AcutePancreatiti.vue?vue&type=style&index=0&id=1f76f3ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76f3ee",
  null
  
)

export default component.exports